import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { scaleIn, slideMenu, slideIn, fadeInOut } from '../../shared/animations/modal.animation';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.css'],
  animations: [scaleIn, slideMenu, slideIn, fadeInOut]
})
export class FiltersComponent implements OnInit {

  @Input() closable = true;
  @Input() visible =false; 
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() filterData = new EventEmitter<any[]>();
  filterArray = [];
  categories: any;
  userGroup: string;
  user: any;
  username: string;
  isHidden: boolean;
  userLoggedOff: boolean;

  constructor(@Inject(DOCUMENT) private document: any) { 
    this.categories = [
      {id:1,value:'Arts',isSelected:false},
      {id:2,value:'Music',isSelected:false},
      {id:3,value:'Sport',isSelected:false},
      {id:4,value:'Conference & Seminars',isSelected:false},
      {id:5,value:'Nature and Wildlife',isSelected:false},
      {id:6,value:'School Sponsorships',isSelected:false},
      {id:7,value:'Food and lifestyle',isSelected:false},
      {id:8,value:'Festival',isSelected:false},
      {id:9,value:'Fairs',isSelected:false},
      {id:10,value:'Bespoke Event',isSelected:false},
      {id:11,value:'Awards',isSelected:false}
    ];

    this.getCurrentAuthenticatedUser();
  }

  ngOnInit() {
  }

  getCurrentAuthenticatedUser(){
    Auth.currentAuthenticatedUser()
      .then((user) => {
        
        this.user = user;
        
		    this.username = user.attributes.name+" "+user.attributes.family_name;
        this.isHidden = false;
        this.userLoggedOff = false;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        // console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]);
        // console.log('header user', user);

      },
        (error) => {
          // console.log("authentication error", error);

          this.isHidden = true;
        });
  }

  onChecked(event: any){
    // console.log("Checked: ",event.target.value);

    if (this.userGroup === 'properties' || this.userGroup === 'sponsors') {
      if(!event.target.checked){
        this.remove(event.target.value);
      }else{
        this.filterArray.push({ "match" : { "propType" : event.target.value } });
      }
    }
    else {
      alert('Please Login to perform this action!'); 
    }
  }

  remove(category: any){
    if (this.filterArray !== null){ 
      var size = this.filterArray.length;
       for (var x =0 ; x< size ; x++){
          console.log ("remove loop: ",this.filterArray [x]);
          if (this.filterArray [x].match.propType == category){
            console.log("Remove: ",category);
            this.filterArray.splice (x,1);
            break;
          }
       }
    }
    // console.log("filterArray: ", this.filterArray);
  }

  onApplyFilters(){
    // console.log("filterArray: ", this.filterArray);
    this.filterData.emit(this.filterArray);
    this.close();
  }

  clear() {
    this.filterArray = [];
    this.categories = [
      {id:1,value:'Arts',isSelected:false},
      {id:2,value:'Music',isSelected:false},
      {id:3,value:'Sport',isSelected:false},
      {id:4,value:'Conference & Seminars',isSelected:false},
      {id:5,value:'Nature and Wildlife',isSelected:false},
      {id:6,value:'School Sponsorships',isSelected:false},
      {id:7,value:'Food and lifestyle',isSelected:false},
      {id:8,value:'Festival',isSelected:false},
      {id:9,value:'Fairs',isSelected:false},
      {id:10,value:'Bespoke Event',isSelected:false},
      {id:11,value:'Awards',isSelected:false}
    ];
    
    this.onApplyFilters();
  }

  close() {
    this.document.body.style.overflow = 'visible';
    this.visible = false;
    this.visibleChange.emit(this.visible);
    setTimeout(() => {
    }, 1000);
  }

  show(): void {
    this.document.body.style.overflow = 'hidden';
    this.visible = true;
  }

}
